module.exports = __webpack_public_path__ + "static/media/step1.b2139fa3.svg";